import React, { useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Badge,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
} from "reactstrap";
import {
  useApproveOrders,
  useDeclineOrders,
  useGetAllGeneralOrder,
  useUpdateGeneralOrders,
} from "../../../../api/orders";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableItem,
  DataTableRow,
  Icon,
  PaginationComponent,
  PreviewAltCard,
} from "../../../../components/Component";
import Content from "../../../../layout/content/Content";
import Head from "../../../../layout/head/Head";
import { formatDayTime, formatter, truncateText } from "../../../../utils/Utils";
import LoadingSpinner from "../../../components/spinner";
import { FilterOptions } from "../tables/filter-select";
import Search from "../tables/Search";
import SortToolTip from "../tables/SortTooltip";
import { orderfilterStatus } from "./OrderData";
const Orders = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const itemsPerPage = searchParams.get("limit") ?? 100;
  const currentPage = searchParams.get("page") ?? 1;
  const status = searchParams.get("status") ?? "";
  const search = searchParams.get("search") ?? "";

  const { isLoading, data: allGeneralOrders } = useGetAllGeneralOrder(currentPage, itemsPerPage, status, search);
  const { mutate: approve } = useApproveOrders();
  const { mutate: decline } = useDeclineOrders();
  const { mutate: update } = useUpdateGeneralOrders();

  const [onSearch, setonSearch] = useState(false);

  // Change Page
  const paginate = (pageNumber) => {
    setSearchParams((searchParams) => {
      searchParams.set("page", pageNumber);
      return searchParams;
    });
  };

  // Status Colors
  const statusColor = useCallback((status) => {
    if (status === "pending" || status === "processing" || status === "unpaid") {
      return "warning";
    } else if (status === "confirmed" || status === "shipped" || status === "transit") {
      return "info";
    } else if (status === "delivered") {
      return "success";
    } else if (status === "paid" || status === "transferred") {
      return "secondary";
    } else {
      return "danger";
    }
  }, []);

  // console.log(allGeneralOrders);

  return (
    <React.Fragment>
      <Head title="Orders"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Orders</BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <Card>
            <DataTable className="card-stretch">
              <Nav tabs className="nav nav-tabs nav-tabs-card">
                <NavItem>
                  <NavLink
                    tag="a"
                    href="#tab"
                    className={status === "" ? "active" : ""}
                    onClick={(ev) => {
                      ev.preventDefault();
                      setSearchParams({ status: "" });
                    }}
                  >
                    All
                  </NavLink>
                </NavItem>
                {orderfilterStatus[0]?.options?.map((item, index) => (
                  <NavItem key={index}>
                    <NavLink
                      tag="a"
                      href="#tab"
                      className={status === item?.value ? "active" : ""}
                      onClick={(ev) => {
                        ev.preventDefault();
                        setSearchParams({ status: item?.value });
                      }}
                    >
                      {item.label}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              <div className="card-inner">
                <div className="card-title-group">
                  <div className="card-title">
                    <h5 className="title">All Orders</h5>
                  </div>
                  <div className="card-tools me-n1">
                    <ul className="btn-toolbar gx-1">
                      <li>
                        <Button
                          href="#search"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setonSearch(true);
                          }}
                          className="btn-icon search-toggle toggle-search"
                        >
                          <Icon name="search"></Icon>
                        </Button>
                      </li>
                      <li className="btn-toolbar-sep"></li>
                      <li>
                        <FilterOptions options={orderfilterStatus} />
                      </li>
                      <li>
                        <UncontrolledDropdown>
                          <DropdownToggle tag="a" className="btn btn-trigger btn-icon dropdown-toggle">
                            <Icon name="setting"></Icon>
                          </DropdownToggle>
                          <DropdownMenu end className="dropdown-menu-xs">
                            <SortToolTip />
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </li>
                    </ul>
                  </div>
                  {/* SEARCH COMPONENT */}
                  <Search onSearch={onSearch} setonSearch={setonSearch} placeholder="name" />
                </div>
              </div>
              {isLoading ? (
                <LoadingSpinner />
              ) : allGeneralOrders?.totalDocuments > 0 ? (
                <>
                  <DataTableBody bodyclass="nk-tb-tnx is-compact">
                    <DataTableHead className="nk-tb-item">
                      <DataTableRow className="nk-tb-col-check">
                        <span>S/N</span>
                      </DataTableRow>

                      {/* TABLE HEADING */}
                      {/* <DataTableRow>
                      <span className="sub-text">Order</span>
                    </DataTableRow> */}
                      <DataTableRow>
                        <span className="sub-text">Buyer name</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Phone</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Amount</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Location</span>
                      </DataTableRow>

                      <DataTableRow>
                        <span className="sub-text">Items</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Status</span>
                      </DataTableRow>
                      <DataTableRow>
                        <span className="sub-text">Date</span>
                      </DataTableRow>

                      <DataTableRow className="nk-tb-col-tools">
                        <ul className="nk-tb-actions gx-1 my-n1">
                          <li style={{ pointerEvents: "none" }}>
                            <UncontrolledDropdown>
                              <DropdownToggle tag="a" className="btn btn-trigger dropdown-toggle btn-icon me-n1">
                                <Icon name="more-h"></Icon>
                              </DropdownToggle>
                            </UncontrolledDropdown>
                          </li>
                        </ul>
                      </DataTableRow>
                    </DataTableHead>

                    {allGeneralOrders?.data?.map((item, idx) => (
                      <DataTableItem key={item._id}>
                        {/* <DataTableRow className="nk-tb-col-check">
                        <span>{idx + 1}</span>
                      </DataTableRow> */}
                        <DataTableRow>
                          <a href="#id" onClick={(ev) => ev.preventDefault()}>
                            #{idx + 1}
                          </a>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-sub">{item?.buyer?.buyerName}</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-sub">{item?.buyer?.hotline}</span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-sub">
                            {formatter(item?.orderBreakdown?.currency || "NGN").format(
                              item?.orderBreakdown?.grandTotal || 0
                            )}
                          </span>
                        </DataTableRow>
                        <DataTableRow>
                          <span className="tb-sub">
                            {`${item.buyer?.shippingAddress?.state}/ ${item.buyer?.shippingAddress?.country}`}
                          </span>
                        </DataTableRow>

                        {/* {item.status === "unpaid" ? (
                        <DataTableRow size="md">
                          {item.products && item.products.length === 1 ? (
                            <span className="tb-sub text-primary">
                              {truncateText(item?.products[0]?.productName, 25)}
                            </span>
                          ) : (
                            <span className="tb-sub text-primary">{item?.products?.length} items</span>
                          )}
                        </DataTableRow>
                      ) : ( */}
                        <DataTableRow>
                          {item?.orders && item.orders?.length === 1 ? (
                            <span className="tb-sub text-primary">
                              {truncateText(item?.orders[0]?.product.productName, 18)}
                            </span>
                          ) : (
                            <span className="tb-sub text-primary">{item?.orders?.length} items</span>
                          )}
                        </DataTableRow>

                        <DataTableRow>
                          {/* <span className={`dot bg-${item.status === "paid" ? "success" : "warning"} d-sm-none`}></span> */}
                          <Badge
                            className="badge-sm badge-dot has-bg d-inline-flex ccap"
                            color={statusColor(item.status)}
                          >
                            {item.status}
                          </Badge>
                        </DataTableRow>

                        <DataTableRow>
                          <span style={{ whiteSpace: "nowrap" }}>{formatDayTime(item?.createdAt)}</span>
                        </DataTableRow>
                        {/* )} */}

                        <DataTableRow className="nk-tb-col-tools">
                          <ul className="nk-tb-actions gx-1">
                            <li>
                              <UncontrolledDropdown>
                                <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
                                  <Icon name="more-h"></Icon>
                                </DropdownToggle>
                                <DropdownMenu end>
                                  <ul className="link-list-opt no-bdr">
                                    <li>
                                      <DropdownItem
                                        tag="a"
                                        href="#orderdetails"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          navigate(
                                            `${process.env.PUBLIC_URL}/orders/order-details/${item._id}?type=order-summary`
                                          );
                                        }}
                                      >
                                        <Icon name="eye"></Icon>
                                        <span>Order Details</span>
                                      </DropdownItem>
                                    </li>
                                    {item?.status === "transferred" && (
                                      <>
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              approve({ orderSummaryId: item?._id });
                                              // mutate({ productId: item?._id, action: "approved" });
                                            }}
                                          >
                                            <Icon name="thumbs-up"></Icon>
                                            <span>Approve</span>
                                          </DropdownItem>
                                        </li>
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              decline({ orderSummaryId: item?._id });

                                              // mutate({ productId: item?._id, action: "approved" });
                                            }}
                                          >
                                            <Icon name="na"></Icon>
                                            <span>Decline</span>
                                          </DropdownItem>
                                        </li>
                                      </>
                                    )}
                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status !== "shipped" &&
                                      item.status !== "confirmed" &&
                                      item.status !== "refunded" &&
                                      item.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item?._id, status: "confirmed" });
                                            }}
                                          >
                                            <Icon name="ticket"></Icon>
                                            <span>Mark as confirmed</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {item.status !== "delivered" &&
                                      item.status !== "pending" &&
                                      item.status !== "cancelled" &&
                                      item.status !== "refunded" &&
                                      item.status !== "transit" &&
                                      item.status !== "confirmed" &&
                                      item.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item?._id, status: "delivered" });
                                            }}
                                          >
                                            <Icon name="done"></Icon>
                                            <span>Mark as Delivered</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status !== "in process" &&
                                      item.status !== "pending" &&
                                      item?.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item._id, status: "processing" });
                                            }}
                                          >
                                            <Icon name="swap-v"></Icon>
                                            <span>Mark as Processing</span>
                                          </DropdownItem>
                                        </li>
                                      )}

                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status !== "transit" &&
                                      item.status !== "pending" &&
                                      item.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item._id, status: "transit" });
                                            }}
                                          >
                                            <Icon name="swap-v"></Icon>
                                            <span>Mark as In Transit</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status !== "shipped" &&
                                      item.status !== "pending" &&
                                      item.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item?._id, status: "shipped" });
                                            }}
                                          >
                                            <Icon name="truck"></Icon>
                                            <span>Mark as Shipped</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status !== "cancelled" &&
                                      item.status !== "unpaid" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item?._id, status: "cancelled" });
                                            }}
                                          >
                                            <Icon name="cross"></Icon>
                                            <span>Mark as Cancelled</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {item.status !== "delivered" &&
                                      item.status !== "refunded" &&
                                      item.status === "cancelled" &&
                                      item.status !== "pending" && (
                                        <li>
                                          <DropdownItem
                                            tag="a"
                                            href="#dropdown"
                                            onClick={(ev) => {
                                              ev.preventDefault();
                                              update({ orderSummaryId: item?._id, status: "refunded" });
                                            }}
                                          >
                                            <Icon name="invest"></Icon>
                                            <span>Mark as Refunded</span>
                                          </DropdownItem>
                                        </li>
                                      )}
                                    {/* {item.status !== "delivered" &&
                                    item.status !== "refunded" &&
                                    item.status !== "failed" && (
                                      <li>
                                        <DropdownItem
                                          tag="a"
                                          href="#dropdown"
                                          onClick={(ev) => {
                                            ev.preventDefault();
                                            update({ orderId: item?._id, state: "closed", status: "failed" });
                                          }}
                                        >
                                          <Icon name="cross"></Icon>
                                          <span>Mark as Failed</span>
                                        </DropdownItem>
                                      </li>
                                    )} */}
                                  </ul>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </li>
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    ))}
                  </DataTableBody>

                  <PreviewAltCard>
                    {allGeneralOrders?.totalDocuments > 0 && (
                      <PaginationComponent
                        itemPerPage={itemsPerPage}
                        totalItems={allGeneralOrders?.totalDocuments}
                        paginate={paginate}
                        currentPage={Number(currentPage)}
                      />
                    )}
                  </PreviewAltCard>
                </>
              ) : (
                <div className="text-center" style={{ paddingBlock: "1rem" }}>
                  <span className="text-silent">No orders found</span>
                </div>
              )}
            </DataTable>
          </Card>
        </Block>

        {/* MODAL DETAILS */}
      </Content>
    </React.Fragment>
  );
};

export default Orders;
